import Icon from './Icon';
import { useInstallApp } from '../hooks/useInstallApp';

// Offering to add the app to a phone's home screen.
//
// The two platforms need different handling, and neither is a button you can
// simply render.
//
// Android and desktop Chrome fire beforeinstallprompt when they judge the site
// installable, and hand over an object that can be shown later -- but only once,
// and only from a real user gesture. That event is caught in useInstallApp,
// at import, because it can fire before this component has mounted.
//
// iOS has no such event and no API. Safari installs only through Share > Add to
// Home Screen, so the honest thing is to say that, and only to people who could
// act on it.
//
// Dismissing is no longer the end of it: the account menu carries the same
// offer, so a "Not now" -- or a mis-tap -- is recoverable.
const InstallApp = () => {
  const { canPrompt, dismissed, installed, needsShare, promptInstall, dismiss } = useInstallApp();

  if (installed || dismissed || (!canPrompt && !needsShare)) return null;

  return (
    <div className="install" role="status">
      <div>
        <strong>Add Prayer Box to your home screen</strong>
        <small>
          {canPrompt
            ? 'It opens like an app, without the browser around it.'
            : 'Tap the Share button, then “Add to Home Screen”.'}
        </small>
      </div>
      <div className="install__actions">
        {canPrompt && (
          <button type="button" className="btn btn--primary btn--sm" onClick={promptInstall}>
            <Icon name="download" size={14} />Add
          </button>
        )}
        <button type="button" className="btn btn--sm" onClick={dismiss}>Not now</button>
      </div>
    </div>
  );
};

export default InstallApp;
